import React from "react";
import { Link } from "react-router-dom";
import LegalDocumentLayout from "./LegalDocumentLayout";

export default function PrivacyPolicy() {
  return (
    <LegalDocumentLayout title="Privacy policy">
      <h2>Who we are</h2>
      <p>
        Gem Fashion Studios operates this clothing-rental website. This policy explains what personal information we
        collect, why we use it, and the choices available to you.
      </p>

      <h2>What we collect</h2>
      <ul>
        <li>Account and checkout data: name, email, mobile number, delivery address.</li>
        <li>Rental information: selected garments, event or rental dates, sizes, and variants.</li>
        <li>Technical information: device, browser, network, session, and website-usage information.</li>
        <li>Location information when you choose to provide or allow it for delivery-area checks.</li>
      </ul>

      <h2>Why we use it</h2>
      <p>
        We use this information to manage accounts, confirm and fulfil rentals, coordinate delivery and returns, process
        payments, provide customer support, prevent fraud, maintain business records, and send marketing only where
        permitted or consented to.
      </p>

      <h2>Sharing</h2>
      <p>
        We share information only as needed with service providers such as hosting, email or SMS, payment providers
        including Razorpay, and delivery or pickup partners. We may also disclose information when required by law or to
        protect customers, our business, or the website.
      </p>

      <h2>Retention & rights</h2>
      <p>
        We keep order, payment, and invoice records for as long as reasonably needed for the rental, customer support,
        accounting, tax, fraud prevention, and legal obligations. Other information is deleted or anonymised when it is no
        longer needed.
      </p>
      <p>
        To request access to or correction of your personal information, or to withdraw a marketing preference, contact
        gemboutiqueinquiries@gmail.com. We may verify your identity before acting on a request.
      </p>

      <h2>Cookies</h2>
      <p>
        See our <Link to="/cookie-policy">cookie policy</Link> for information about required and optional cookies and how
        to manage them.
      </p>
    </LegalDocumentLayout>
  );
}
